import React, { useState } from 'react';
import styles from '../Upload.module.scss';
import { getAssetTypeName, useOpenAsset } from '../../../data/assets/helpers';
import { FileSetOverview } from './FileSetOverview';
import { UploadFile } from '../../../components/files/helpers';
import { UploadProgress } from './UploadProgress';
import { TpAssetInfo } from '../../../data/assets/interfaces';

interface DataUploadOverviewProps {
  ontology: any;
  selectedTemplate: any;
  fileSet: UploadFile[];
  collectionProperties: any;
  setFilesSelected: (newValue: boolean) => void;
}

export function DataUploadOverview(props: DataUploadOverviewProps) {
  const openAsset = useOpenAsset();
  const { ontology, selectedTemplate, fileSet, collectionProperties, setFilesSelected } = props;
  const [validationCheck, setValidationCheck] = useState(false);
  const [startUpload, setStartUpload] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [collectionAsset, setCollectionAsset] = useState<TpAssetInfo | null>(null);
  const [abortController, setAbortController] = useState<AbortController | null>(null);
  const [uploadAborted, setUploadAborted] = useState(false);

  const [fileSetAssets, setFileSetAssets] = useState({});

  const validateFiles = () => {
    const requiredProperties = selectedTemplate.fileSetMetadata
      .filter((cm: any) => cm.required)
      .map((cm: any) => cm.id);
    const missingProperties = Object.entries(fileSetAssets).filter(([key, value]) => {
      return requiredProperties.some((rp) => !value[rp]);
    });
    if (missingProperties.length === 0) {
      const controller = new AbortController();
      setAbortController(controller);
      setStartUpload(true);
      setValidationCheck(false);
    } else {
      setValidationCheck(true);
    }
  };

  return (
    <>
      <div className={styles.collectionAssetType}>
        <div className={styles.uploadSectionHeader}>
          {getAssetTypeName(ontology.assetTypes[selectedTemplate.collectionAssetType])}
        </div>

        <div className={styles.autoForm}>
          {Object.entries(collectionProperties).map(([key, value]) => {
            return (
              <div key={`upload-property-${key}`}>
                <div className={styles.uploadKey}>
                  {selectedTemplate.collectionMetadata.find((cm: any) => cm.id === key).name || key}:
                </div>
                <div className={styles.uploadVal}>{value}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.fileSetAssetType}>
        <div className={styles.uploadSectionHeader}>
          {getAssetTypeName(ontology.assetTypes[selectedTemplate.fileSetAssetType], true)}
        </div>
        {startUpload && abortController ? (
          <UploadProgress
            ontology={ontology}
            collectionProperties={collectionProperties}
            selectedTemplate={selectedTemplate}
            fileSetAssets={fileSetAssets}
            setCollectionAsset={setCollectionAsset}
            setUploadComplete={setUploadComplete}
            abortController={abortController}
            uploadAborted={uploadAborted}
            setUploadAborted={setUploadAborted}
          />
        ) : (
          <FileSetOverview
            fileSet={fileSet}
            selectedTemplate={selectedTemplate}
            setFileSetAssets={setFileSetAssets}
            fileSetAssets={fileSetAssets}
            validationCheck={validationCheck}
          />
        )}
      </div>
      {startUpload && abortController ? (
        uploadComplete && collectionAsset ? (
          <div className={styles.buttonSection}>
            <button
              onClick={() => {
                openAsset(collectionAsset.id);
              }}
            >
              Go to new {getAssetTypeName(ontology.assetTypes[selectedTemplate.collectionAssetType])}
            </button>
          </div>
        ) : uploadAborted ? (
          <div className={styles.buttonSection}>
            <button
              onClick={() => {
                setStartUpload(false);
                setUploadAborted(false);
              }}
            >
              Back
            </button>
          </div>
        ) : (
          <div className={styles.buttonSection}>
            <button
              style={{ backgroundColor: 'red' }}
              onClick={() => {
                if (abortController) {
                  abortController.abort();
                }
              }}
            >
              Abort
            </button>
          </div>
        )
      ) : (
        <div className={styles.buttonSection}>
          <button
            onClick={() => {
              setFilesSelected(false);
            }}
          >
            Back
          </button>
          <button
            onClick={() => {
              validateFiles();
            }}
          >
            Submit
          </button>
        </div>
      )}
    </>
  );
}
